import React, { useState, useEffect, useCallback } from 'react';
import { API_BASE, apiHeaders, leseFallback } from '../lib/api';
import { KlasseFachEintrag } from '../types';

interface KlassenContextValue {
  meineKlassen: KlasseFachEintrag[];
  reloadMeineKlassen: () => void;
}

const KlassenCtx = React.createContext<KlassenContextValue | null>(null);

export function useKlassen(): KlassenContextValue {
  const ctx = React.useContext(KlassenCtx);
  if (!ctx) throw new Error('useKlassen außerhalb KlassenProvider');
  return ctx;
}

export function KlassenProvider({ children, eingeloggt }: { children: React.ReactNode; eingeloggt: boolean }) {
  const [meineKlassen, setMeineKlassen] = useState<KlasseFachEintrag[]>([]);

  const reloadMeineKlassen = useCallback(() => {
    if (!eingeloggt) { setMeineKlassen([]); return; }
    fetch(`${API_BASE}/api/meine-klassen`, { headers: apiHeaders() })
      .then(leseFallback<KlasseFachEintrag[]>([], '/api/meine-klassen'))
      .then((data: KlasseFachEintrag[]) => setMeineKlassen(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [eingeloggt]);

  useEffect(() => {
    reloadMeineKlassen();
  }, [reloadMeineKlassen]);

  return (
    <KlassenCtx.Provider value={{ meineKlassen, reloadMeineKlassen }}>
      {children}
    </KlassenCtx.Provider>
  );
}
